import React from 'react';
import { RocheTextLink as RocheTextLinkType } from '../../types/global';
import { BlokToComponentProps } from '../../helpers/blok-to-component/types';
import { Link } from '../../services/navigation/types';
import { NavigationService } from '../../services/navigation';

export type RocheTextLinkTypes = BlokToComponentProps<
  RocheTextLinkType & {
    link?: Link;
    right_icon?: string;
    left_icon?: string;
    'right-icon'?: string;
    'left-icon'?: string;
  }
>;

export const RocheTextLink = ({
  blok: {
    link,
    text,
    target,
    right_icon: rightIconCamelCase,
    left_icon: leftIconCamelCase,
    'left-icon': leftIconKebabCase,
    'right-icon': rightIconKebabCase,
    type,
  },
  slot,
}: RocheTextLinkTypes): JSX.Element => {
  const leftIcon = leftIconCamelCase || leftIconKebabCase;
  const rightIcon = rightIconCamelCase || rightIconKebabCase;

  const maskedHref = NavigationService.getParsedNavigationLink(link);

  return (
    <roche-text-link
      href={maskedHref}
      slot={slot}
      target={target}
      left-icon={leftIcon}
      right-icon={rightIcon}
      text={text}
      type={type}
    >
      <a href={maskedHref}>{text}</a>
    </roche-text-link>
  );
};
